<template>
  <div class="NotificationsListItem">
    <v-list-item
      class="NotificationsListItem__list-item"
    >
      <v-list-item-action class="NotificationsListItem__action">
        <div>
          <span
            v-if="!is_read"
            class="NotificationsListItem__not-read-mark"
          />

          <v-list-item-action-text
            class="NotificationsListItem__action-text"
            v-html="createdAt"
          />
        </div>

        <BTooltipButton
          v-if="!is_read"
          icon="mdi-checkbox-multiple-marked-outline"
          tooltip="Прочитать"
          depressed
          small
          rounded
          left
          class-button="NotificationsListItem__button-read"
          @click="$emit('action:readed', toggleLoading)"
        />
      </v-list-item-action>

      <v-list-item-content class="NotificationsListItem__title-wrapper">
        <v-list-item-title
          class="NotificationsListItem__title"
          v-text="title"
        />
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="description" class="NotificationsListItem__description-wrapper">
      <v-list-item-content class="NotificationsListItem__description">
        <v-list-item-subtitle
          class="NotificationsListItem__subtitle"
          v-html="description"
        />
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import { dateFormatter } from '@/helpers/dateFormatter'
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export default {
  name: 'NotificationsListItem',
  components: {
    BTooltipButton,
  },
  inheritAttrs: false,
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
    },
    created_at: String,
    is_read: Boolean,
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    createdAt() {
      let created_at = dateFormatter(this.created_at, 'DD MMM YYYY / HH:mm')
      created_at = created_at.split(' / ')
      return `<time dateTime="${this.created_at}">${created_at[0]}<span> / </span>${created_at[1]}</time>`
    },
  },
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
  },
}
</script>

<style lang="scss">
.NotificationsListItem {
  $root: &;

  padding-top: 1rem;
  padding-bottom: 1rem;

  &__not-read-mark {
    display: inline-block;
    width: 7px;
    height: 7px;
    margin-right: 7px;
    background-color: $webflow-color-blue-dark;
    border-radius: 50%;
  }

  &__list-item {
    display: block;
  }

  & &__title {
    font-size: 0.875rem;
    line-height: 160%;
    color: $webflow-color-black-2;
    white-space: pre-wrap;
  }

  & &__description-wrapper {
    min-height: auto;
  }

  & &__description {
    padding: 0;
    margin-top: 0.375rem;
  }

  & &__description &__subtitle {
    font-size: 0.75rem;
    line-height: 150%;
    color: $webflow-color-blue-dark-2;
    white-space: pre-wrap;
  }

  & &__list-item &__action {
    flex-direction: row;
    align-items: center;
    align-self: flex-start;
    width: 100%;
    margin: 0;

    #{$root}__action-text {
      color: $webflow-color-blue-dark-2;
      text-transform: uppercase;

      time {
        font-size: 0.625rem;
        line-height: 1rem;

        span {
          display: inline-block;
          margin-right: 0.5rem;
          margin-left: 0.5rem;
          color: $webflow-color-blue-light;
        }
      }
    }
  }

  & &__list-item &__title-wrapper {
    padding: 0;
    margin-top: 0.375rem;
  }

  &__button-read {
    margin: -6px -10px -6px 4px;
  }
}
</style>
